import Pricing from '../shared/pricing/pricing'
import {Zendesk} from '../services/zendesk'


tag pricing-page
	css header ta:center h:250px d:grid ai:center @900:flex-start bgc:teal4 bg:url('svg/pricing-pattern.svg') bgs:cover bgr:no-repeat
		h1 mt:0 @900:16 fs: 3rem
	css section w:100%
	css .container w:100% mx:auto ta:center
	
	css .plan mb:16 @900:0
		.content p:10 m:4 bd:1px solid $medium-grey rd:20px ta:center bgc:white h:min-content 
			.free, .pro, .cohort zi:4
			h4 fw:600 my:6
			svg zi:3
	css .plan-perks fw:bold fs:1.5rem mt:1.5rem mb:1.5rem
	css .pro bxs:0px 2px 40px 0px rgba(0,0,0,0.3) t:0 @900:-50px
	css .banner bgc:$lemony p:2 1 my:8 mx:auto w:200px rd:20px ta:center rotate:-3deg c:black fw:600
	css .usp mb:3
	css .strike td:line-through
	css .coupon font-style:italic fw:600 mb:4 rd:10px
	css .underline::after content:" " h:2.5 w:100% bg:amber3/60 pos:absolute b:-6px l:0 rdtr:xl rdbl:md
	# All prices - in the future this can includes cohort
	pricing = loading?: yes
	get loading? do pricing.loading?
	use-usd = no
	# since we do not show a plan selector we can´t really show the coupon price as that applies to different
	# plan durations. We could show if the price is reduced to 0.
	get discount-intro
		<p[mb:4]>
			if loading?
				<span> "..."
			elif pricing.trial-available?
				<span.underline> "Free trial unlocked"
			else
				<span.underline> "{pricing.annual..discount.percent_text}% Discount applied"

	get bootcamp-intro
		return <span[td: line-through]> "{pricing.bootcamp.price.plan_text} per month" if pricing..bootcamp3..discounted?
		""

	get bootcamp-price
		return "..." if loading?
		
		if pricing..bootcamp3..discounted?
			return "{pricing.bootcamp3.price.plan_text} / Quarter"	
		"{pricing.bootcamp3.price.plan_text} / Quarter"

	get pro-price do
		return "..." if loading?
		if pricing.trial-available?
			return "Claim your free trial!" 
		"{pricing.annual.price.monthly_text} / Month"

	def mount
		window.zendesk ||= new Zendesk
		use-usd = window.location.href.indexOf('use_usd') > -1 ? yes : no
		load-pricing!
		window.$once('userdata').then do load-pricing!

	def hydrate
		innerHTML = ''
		schedule!
		render!

	def load-pricing
		# return if window.location.hash == '#join' # Skip if join-modal is open
		let urlcpn = new URL(window.location.href).searchParams.get('coupon')
		pricing = new Pricing
			pricing: store.me..pricing
			country: store.me..country
			coupons: store.me..coupons
			url_coupon: urlcpn
			subscription: store.subscription
			usd: use-usd

	def render
		css .plan > svg m:0 auto l:0 r:0 
		<self>
			<header>
				<h1 @intersect.out=window.flags.add('mod-sticky-header') @intersect.in=window.flags.remove('mod-sticky-header')> "Scrimba plans"
			<section>
				<.container[py:2 d:grid gtc:1fr @900:repeat(3,33%) grg:3rem max-width:1300px]>
					<.plan[order:3 @900:0]>
						<svg[pos:absolute t:-80px w:110px] src="svg/peep-what.svg">
						<.content.newbie>
							<h3> "Free member"
							<p> "Learn basic HTML, CSS, JavaScript and React"
							<p.plan-perks> "Access to intro courses"
							<p.plan-perks> "Basic access to community"
							<a.button.rounded.sm[d:none d@guest:block] href="#sign-up"> "Create Free Account"
							<a.button.rounded.sm.disabled[d@guest:none] href="#sign-up"> "You already got it!"

					<.plan[d:flex jc:center]>
						<svg[pos:absolute t:-80px @900:-130px l:150px h:115px] src="svg/peep-gamer.svg">
						<.content.pro>
							<h3[px:6]> "Pro member"
							<p> "All the content you need to become a hireable developer"
							<p.plan-perks> "77h Frontend Career Path"
							<p.plan-perks> "All 60+ courses"
							<p.plan-perks> "Full access to community"
							<p.plan-perks> "Course certificates"

							<p.small[mt:2]> discount-intro
							<a.button.rounded[d@subscriber:none pos:relative] href="#join"> pro-price
							<a.button.rounded.disabled[d:none d@subscriber:block] href="#join"> "You are already pro!"
							<p.small[mt:2 d@subscriber:none]> "*Billed yearly."

					<.plan>
						<svg[pos:absolute t:-65px] src="svg/peeps-crowd2.svg">
						<.content.cohort>
							<h3> "Team"
							<p> "Train your team in web development and "
								<a href="/scrim/coccb421586fbba068cc26aa1" target='_blank'> "AI engineering"
							<p.plan-perks> "Everything in Pro"
							<p.plan-perks> "Track learner activity"
							<p.plan-perks> "Bulk discount"
							<p[mb: 1rem]> "Visit our " 
								<a href="/teams" target='_blank'> "Teams page" 
								" to learn more"
							<a.button.rounded href="#teams"> "Request team plan"

					# <.plan>
					# 	<svg[pos:absolute t:-65px] src="svg/peeps-crowd2.svg">
					# 	<.content.cohort>
					# 		<h3> "Bootcamp"
					# 		<p> "Fast-track your job readiness"
					# 		<p.plan-perks> "Everything in Pro"
					# 		<p.plan-perks> "Code reviews"
					# 		<p.plan-perks> "Dedicated study group"
					# 		<p.plan-perks> "Teacher-led sessions"
					# 		# NOTE: Uncomment this for the monthly-vs-quarterly discount for bootcamp:
					# 		<p[mt:2]> bootcamp-intro
					# 		<a[mt:2 d@bootcamp:none].button.rounded href="#bootcamp"> bootcamp-price

					# 		# <a[mt:2 d@bootcamp:none].button.rounded href="https://scrimba.com/pricing?coupon=Bootcamp%20Sale%20-20%#bootcamp"> "$150 off!💰"
					# 		<a.button.rounded.disabled[d:none d@bootcamp:block] href="#join"> "You are already a Bootcamper!"
					# 		<a.small.link href="/bootcamp"> "Learn more" 

				# <.container[pt:0]>
				# 	<p.bold[max-width:initial]> "Looking for the Scrimba Bootcamp?"
				# 	<p[max-width: initial]> 
				# 		<a[cursor:pointer] href="/bootcamp#bootcamp"> "Find it here" 
				# 		" 👈"	
				

			<section[bgc:$medium-moss]>
				<.container[px:8]>
					<h2[mb:6 fs: 2rem]> "Buy with confidence"
					<.usps[d:grid gtc:1fr @sm:repeat(3,1fr) gcg:2rem]>
						<.usp>
							<p.bold> "Money Back Guarantee"
							<p> "Full 7-day guarantee, no questions asked."
						<.usp>
							<p.bold> "Keep Discount For Life"
							<p> "Your discount stays for as long as you subscribe."
						<.usp>
							<p.bold> "Cancel Whenever"
							<p> "No lock-in period. Cancel whenever you want."
